<template>
  <div class="free-car-item d-flex align-items-center justify-content-center">
    <slot name="freeItem"></slot>
  </div>
</template>

<script>
import './vehicleCardFreeItem.scss'
export default {}
</script>

<style lang="scss">

</style>